import {
  OFFLINE_OPERATION_TYPE,
  addOfflineOperationDependency,
  enqueueOfflineOperation,
  listOfflineOperations,
  operationToOfflineSale,
  subscribeOfflineOperations,
  syncOfflineOperations,
} from './offlineOperationsQueue';

export const provisionalSaleNumber = (idempotencyKey, createdAt = Date.now()) => {
  const date = new Date(createdAt);
  const ymd = Number.isNaN(date.getTime())
    ? '00000000'
    : date.toISOString().slice(0, 10).replace(/-/g, '');
  const suffix = String(idempotencyKey || '').replace(/[^A-Za-z0-9]/g, '').slice(-8).toUpperCase() || 'LOCAL';
  return `PEND-${ymd}-${suffix}`;
};

export async function enqueueOfflineSale({
  saleDoc, storeId, idempotencyKey, fingerprint, dependsOn = [], reconcileOperationId = null,
}) {
  if (!saleDoc?.turnId || !idempotencyKey || !fingerprint) {
    throw new Error('La venta offline no tiene la información necesaria para guardarse.');
  }
  const createdAt = Date.now();
  const provisionalNumber = provisionalSaleNumber(idempotencyKey, createdAt);
  const operation = await enqueueOfflineOperation({
    id: idempotencyKey,
    type: OFFLINE_OPERATION_TYPE.SALE,
    priority: 30,
    storeId,
    cashId: saleDoc.turnId,
    ownerUid: saleDoc.sellerUid || null,
    createdAt,
    occurredAt: createdAt,
    dependsOn,
    payload: { saleDoc, idempotencyKey, fingerprint, provisionalNumber },
  });
  if (reconcileOperationId) {
    await addOfflineOperationDependency(reconcileOperationId, operation.id);
  }
  return operationToOfflineSale(operation);
}

export async function listOfflineSales() {
  const records = await listOfflineOperations();
  return records
    .filter((record) => record.type === OFFLINE_OPERATION_TYPE.SALE)
    .map(operationToOfflineSale);
}

export async function countPendingOfflineSales(cashId = null) {
  const records = await listOfflineSales();
  return records.filter((record) => !cashId || String(record.cashId) === String(cashId)).length;
}

export function syncOfflineSales(processor, { onProgress } = {}) {
  return syncOfflineOperations({
    [OFFLINE_OPERATION_TYPE.SALE]: (operation) => processor(operationToOfflineSale(operation)),
  }, {
    onProgress: (operation) => onProgress?.(operationToOfflineSale(operation)),
  });
}

export function subscribeOfflineSales(callback) {
  return subscribeOfflineOperations(callback);
}
